<template>
  <router-view>
  </router-view>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState("tickets", ["categories"])
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("tickets", ["getCategories"]),
    initialize() {
      if (this.categories.length == 0) {
        this.getCategories({ per_page: 100 });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>